import { Box, Button, Flex, Image, Skeleton } from '@chakra-ui/react'

export const SkeletonLoading = () => {
  return Array.from({ length: 3 }).map((_, index) => (
    <Flex
      key={index}
      alignItems="center"
      justifyContent="space-between"
      p={2}
      borderRadius="md"
      bg="gray.100"
      border="1px"
      borderColor="gray.200"
      shadow="sm"
    >
      <Flex alignItems="center" gap={4}>
        <Skeleton>
          <Image fallbackSrc="https://via.placeholder.com/150" boxSize="100px" alt="Nome do produto" />
        </Skeleton>
        <Flex flexDir="column" gap={1}>
          <Skeleton w="fit" bg="gray.300">
            <Box opacity={0}>
              Cód. prod: <strong>000000</strong>
            </Box>
          </Skeleton>
          <Skeleton w="fit" bg="gray.300">
            <Box opacity={0}>
              Nome do Produto: <strong>000000</strong>
            </Box>
          </Skeleton>
          <Skeleton w="fit" bg="gray.300">
            <Box opacity={0}>
              Quantidade negociada: <strong>000000</strong>
            </Box>
          </Skeleton>
        </Flex>
      </Flex>
      <Flex alignItems="center" gap={4}>
        <Button colorScheme="blue" isLoading disabled>
          Alterar layout
        </Button>
      </Flex>
    </Flex>
  ))
}
